import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { yieldCallback } from '@zillow/yield-callback';
import { IconChevronRightOutline, IconChevronLeftOutline } from '@zillow/constellation';

var ARROW_COLUMN_WIDTH = '35px';
var MediaCarouselControl = /*#__PURE__*/styled.span.withConfig({
  componentId: "sc-112echu-0"
})(["position:absolute;display:flex;align-items:center;justify-content:center;top:0;bottom:0;width:", ";&:hover{cursor:pointer;}z-index:5;"], ARROW_COLUMN_WIDTH);
var CarouselNavigation = function CarouselNavigation(_ref) {
  var onLeftButtonClick = _ref.onLeftButtonClick,
    onRightButtonClick = _ref.onRightButtonClick;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(MediaCarouselControl, {
    style: {
      right: 0
    },
    onClick: yieldCallback(function () {
      return onRightButtonClick();
    })
  }, /*#__PURE__*/React.createElement(IconChevronRightOutline, null)), /*#__PURE__*/React.createElement(MediaCarouselControl, {
    style: {
      left: 0
    },
    onClick: yieldCallback(function () {
      return onLeftButtonClick();
    })
  }, /*#__PURE__*/React.createElement(IconChevronLeftOutline, null)));
};
CarouselNavigation.propTypes = process.env.NODE_ENV !== "production" ? {
  onLeftButtonClick: PropTypes.func.isRequired,
  onRightButtonClick: PropTypes.func.isRequired
} : {};
CarouselNavigation.defaultProps = {};
var CarouselNavigation$1 = CarouselNavigation;

export { ARROW_COLUMN_WIDTH, CarouselNavigation$1 as default };
